<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/position/detail/'+id}">职位列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               label-width="80px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>基本信息</h2>
            <hr>
          </el-col>
          <el-form-item label="行业大类:">
            <span v-for="industryType in options.industry_type"
                  v-if="industryType.id === form.industry_type">
              {{industryType.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'industry_type'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="职位类型:">
            <span v-for="positionType in options.position_type"
                  v-if="positionType.id === form.position_type">
              {{positionType.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'position_type'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="岗位名称:">{{form.title}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'title'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="招聘人数:">{{form.hire_number}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'hire_number'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="工作地点:">{{form.province_name}}-{{form.city_name}}-{{form.area_name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {{form.address}}
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'address'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="发布单位:">{{form.employer_name}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'employer_name'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
        </el-row>
        <br>
        <el-row class="text item">
          <el-col :span="24">
            <h2>职位描述</h2>
            <hr>
          </el-col>
          <el-form-item label="工作时间:">{{form.position_period}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'position_period'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="工作班次:">{{form.working_shifts}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'working_shifts'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="工作时长:">{{form.working_hours}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'working_hours'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="性别要求:">
            <span v-for="gender in options.gender"
                  v-if="gender.id === form.gender">
              {{gender.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'gender'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="年龄要求:">{{form.age_range}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'age_range'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="证件要求:">{{form.certificate}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'certificate'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="学历要求:">
            <span v-for="education in options.education"
                  v-if="education.id === form.education">
              {{education.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'education'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="婚姻状况:">
            <span v-for="marriage in options.marriage"
                  v-if="marriage.id === form.marriage">
              {{marriage.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'marriage'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="工作经验:">{{form.working_experience}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'working_experience'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="补充说明:">{{form.other_requirements}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'other_requirements'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
        </el-row>
        <br/>
        <el-row class="text item">
          <el-col :span="24">
            <h2>薪资福利</h2>
            <hr>
          </el-col>
          <el-form-item label="基本薪资:">
            <span v-for="salary in options.salary"
                  v-if="salary.id === form.salary">{{salary.keyword}}</span>
            <span v-for="salaryType in options.salary_type"
                  v-if="salaryType.id === form.salary_type">
              {{salaryType.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'salary'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="提成机制:">{{form.commission}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'commission'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="季度奖金:">{{form.quarterly_bonus}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'quarterly_bonus'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="社保缴纳:">
            <span v-for="insurance in options.insurance"
                  v-if="insurance.id === form.insurance">
              {{insurance.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'insurance'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="加班补助:">{{form.overtime_pay}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'overtime_pay'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="餐饮补助:">{{form.meal_allowance}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'meal_allowance'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="交通补助:">{{form.commute_allowance}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'commute_allowance'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="话费补助:">{{form.phone_allowance}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'phone_allowance'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="其他福利:">{{form.welfare}}</el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'welfare'"
               style="margin-top:-20px;color:red">
            *{{value.message}}
          </div>
          <el-form-item label="结算方式:">
            <span v-for="settlementType in options.settlement_type"
                  v-if="settlementType.id === form.settlement_type">
              {{settlementType.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'settlement_type'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
          <el-form-item label="结算时间:">
            <span v-for="settlementTime in options.settlement_time"
                  v-if="settlementTime.id === form.settlement_time">
              {{settlementTime.keyword}}
            </span>
          </el-form-item>
          <div v-for="value in form.errorFields"
               v-if="value.field === 'settlement_time'"
               style="margin-top:-20px;color:red">*{{value.message}}
          </div>
        </el-row>
      </el-form>
      <el-form ref="form"
               :model="checkForm"
               label-width="80px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>审核信息</h2>
            <hr>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户id:">{{checkForm.userid}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户真名:">{{checkForm.realname}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户等级:">
              <span v-for="value in options.level"
                    v-if="value.id === checkForm.level">
                {{value.keyword}}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="当前状态:">
              <span v-for="value in options.currentstatus"
                    v-if="value.id === checkForm.currentstatus">
                {{value.keyword}}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所在地:">{{checkForm.current_location.system}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号:">{{checkForm.cellphone}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电子邮箱:">{{form.email}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="注册时间:">{{checkForm.registertime}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赏金信息:">可提现金额: {{checkForm.balance}} 冻结金额: {{checkForm.frozenbalance}} 已提现金额:
              {{checkForm.totalwithdraw}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="零豆信息:">积分总数: {{checkForm.points}}&nbsp;&nbsp;&nbsp;&nbsp; 冻结积分:
              {{checkForm.frozenpoints}} &nbsp;&nbsp;&nbsp;&nbsp;已花费积分: {{checkForm.spendpoints}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片证据:">
              <div v-for="value in form.proof">
                <a :href="value"
                   target="_Blank"
                   v-if="value">
                  <img :src="value+'?x-oss-process=image/resize,w_100/auto-orient,1'"
                       width="100px;"
                       height="100px;"
                       style="border-radius:50px">
                </a>
              </div>
              <br/>
              <div v-for="value in form.errorFields"
                   v-if="value.field === 'proof'"
                   style="margin-top:-20px;color:red">
                *{{value.message}}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系电话:">{{form.contactto}}</el-form-item>
            <div v-for="value in form.errorFields"
                 v-if="value.field === 'contactto'"
                 style="margin-top:-20px;color:red">*{{value.message}}
            </div>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发布单位:">
              {{form.employer_name}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row style="text-align:center">
        <Br/>
        <router-link :to="{ path: '/position/audit-table'}">
          <el-button>返回</el-button>
        </router-link>
      </el-row>
    </layout-panel>

  </div>
</template>

<script>
export default {
  data () {
    return {
      creator: this.$route.query.creator,
      id: this.$route.params.id,
      form: {
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        status: null,
        province_name: null,
        city_name: null,
        area_name: null,
        proof: [],
        errorFields: [],
        email: null,
        contactto: null,
      },
      checkForm: {
        userid: null,
        realname: null,
        level: null,
        currentstatus: null,
        current_location: [],
        cellphone: null,
        registertime: null,
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
        frozenpoints: 0,
        points: 0,
        spendpoints: 0,
      },
      options: {
        industry_type: [],
        salary: [],
        position_type: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
        level: [],
        currentstatus: [],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getPostionForm', this.id),
      request('editPostionOptions'),
      request('getUserDetail', this.creator),
      request('getUserRelatedOptions'),
      request('getUserCredit', this.creator),
      request('getUserPoints', this.creator),
    ]).then(([postionForm, postionOptions, userDetail, relatedOptions, userCredit, userPoints]) => {
      (({data}) => {
        filter.setLoop(this.form, data)
      })(postionForm)

      ;(({data}) => {
        filter.setLoop(this.options, data)
      })(postionOptions)

      ;(({data}) => {
        filter.setLoop(this.checkForm, data)
      })(userDetail)

      ;(({data}) => {
        filter.setLoop(this.options, data)
      })(relatedOptions)

      ;(({data}) => {
        filter.setLoop(this.checkForm, data)
      })(userCredit)

      ;(({data}) => {
        filter.setLoop(this.checkForm, data)
      })(userPoints)
    })
  },
  methods: {
    ...Vuex.mapActions(['getPostionForm', 'editPostionOptions', 'getUserCredit', 'getUserPoints', 'getUserDetail', 'getUserRelatedOptions']),

  },
}
</script>



// WEBPACK FOOTER //
// src/views/position/pages/PositionAuditDetail.vue